import { defineRoutes } from '../utils';

/**
 * CRM domain routes — carrier-only master-detail "client workspace"
 * surface mounted under `/crm`. The workspace itself selects a client
 * via `?clientId=`, so most consumers will use `to('crm', { clientId })`.
 *
 * `crm_client_legacy` is the redirect target for the deprecated
 * `/crm/clients/:clientId` URL. The carrier-dashboard's app router
 * resolves it to `/crm?clientId=…` so old bookmarks keep working.
 */
export const crmRoutes = defineRoutes({
  crm: {
    path: '/crm',
    isPublic: false,
    params: {} as {
      /** Selected client id; absent when the workspace is showing the list. */
      clientId?: string;
      /** Active workspace tab (e.g. 'pricing', 'orders'). */
      tab?: string;
      /**
       * Optional agreement to scope the Pricing tab to. When set
       * together with `tab=pricing`, `ClientPricingTab` resolves the
       * agreement and seeds the pricing sheet with `{ kind: 'agreement' }`
       * so the user lands directly in the agreement-scoped price list
       * (used by the AgreementDrawer's "Add route" flow — the
       * RouteEditModal is no longer mounted there).
       */
      agreementId?: string;
    },
  },
  crm_client_legacy: {
    path: '/crm/clients/:clientId',
    isPublic: false,
    params: {} as { clientId: string },
  },
});